// extracted by mini-css-extract-plugin
module.exports = {"root":"TeamSwitcher_root__A5EP6","activity":"TeamSwitcher_activity__MRnls","icon":"TeamSwitcher_icon__IYT9j"};